import availableCareOptions from "features/availableCareOptions";
import { commonConstant } from "../../../../server/triage/constants";

var teleMedName = "Telemedicine";

function checkTeleMedConditionAndMigrate(data, o) {
  if (o.service === teleMedName) {
    if (data.alt === o.service) {
      return null;
    }
  } else {
    var result = migrateValues(data, o);

    if (result != undefined) {
      return result;
    }
  }
}

function migrateValues(data, o) {
  if (data.alt === o.service) {
    return {
      ...data,
      direction: o.direction,
      value: o.score,
    };
  }
}

function findMatchingCareOption(o) {
  // Find matching card data for each recommended option
  var vendorList = o.state.triageResponse.vendorsList;
  for (const data of availableCareOptions) {
    if (vendorList && vendorList.length > 1) {
      var allVendorsArray = [];
      vendorList.map((item) => {
        var vendors = item.nameLocalization.localizations[0].value;
        if (allVendorsArray.indexOf(vendors) === -1) {
          allVendorsArray.push(vendors);
        }
      });
      if (allVendorsArray.length === 0) {
        var arrayZeroResult = checkTeleMedConditionAndMigrate(data, o);
        if (arrayZeroResult != undefined) {
          return arrayZeroResult;
        }
      } else if (allVendorsArray.length >= 1) {
        var result = migrateValues(data, o);
        if (result != undefined) {
          return result;
        }
      } else {
        var elseResult = checkTeleMedConditionAndMigrate(data, o);
        if (elseResult != undefined) {
          return elseResult;
        }
      }
    } else if (vendorList && vendorList.length === 1) {
      var resultSizeOne = migrateValues(data, o);
      if (resultSizeOne != undefined) {
        return resultSizeOne;
      }
    } else {
      var elseZeroResult = checkTeleMedConditionAndMigrate(data, o);
      if (elseZeroResult != undefined) {
        return elseZeroResult;
      }
    }
  }
}

export function generateRecommendedCareOptions({ state, setState }) {
  const recommendedCareOptions = [];
  const topOptions = [];
  const goodOptions = [];
  var careOptionsResponse = state.triageResponse.response;
  if (!state.isTravelAid2) {
    if (careOptionsResponse.message !== commonConstant.NoServiceAvailable) {
      if (
        careOptionsResponse.services != null &&
        careOptionsResponse.services.length > 0
      ) {
        careOptionsResponse.services.map((sr) => {
          const { service, direction } = sr;
          const option = findMatchingCareOption({ service, direction, state });
          if (!option) {
            return;
          }
          if (direction === "Top") topOptions.push(option);
          else if (direction === "Good") goodOptions.push(option);
          else recommendedCareOptions.push(option);
        });
      }
    }
  }
  else {
    //as per #5923 for new triage added constant care-option card
    const telemedicine = { direction: "Top", resultQty: 1, service: "Telemedicine", specialEmergencyFlow: false }
    const medicalFacility = { direction: "Other", resultQty: 1, service: "Medical Facility", specialEmergencyFlow: false }
    const clinic = {direction: "Other", resultQty: 1, service: "Clinic", specialEmergencyFlow: false}
    var newTriageCareOptions = state.isCallCenter 
    ? (state.triageRequest.presentRelatedSymptomSelected.length == 0 && state.triageResponse.vendorsList.length != 0 
      ? [telemedicine, clinic, medicalFacility] 
      : [clinic, medicalFacility]) 
      : (state.triageRequest.presentRelatedSymptomSelected.length == 0 && state.triageResponse.vendorsList.length != 0 
        ? [telemedicine, medicalFacility] 
        : [medicalFacility]) ;
    newTriageCareOptions.map((sr) => {
      const { service, direction } = sr;
      const option = findMatchingCareOption({ service, direction, state });
      if(state.isLoading_RelativeSymptom) {setState({ isLoading_RelativeSymptom:false});}
      if (!option) {
        return;
      }
      if (direction === "Top") topOptions.push(option);
      else if (direction === "Good") goodOptions.push(option);
      else recommendedCareOptions.push(option);
    });
  }
  // Make sure there's at least one Top option

  if (!topOptions.length) {
    const o = goodOptions.shift() || recommendedCareOptions.shift();
    if (o) {
      o.direction = "Top";
      topOptions.push(o);
    }
  }

  // Put these at the start of list
  goodOptions.forEach((o) => recommendedCareOptions.unshift(o));
  topOptions.forEach((o) => recommendedCareOptions.unshift(o));

  const {
    value: selectedCareOptionScore = 0,
    alt: selectedCareOptionName = "",
  } = recommendedCareOptions[0] || {};

  setState({
    triageRequest: {
      ...state.triageRequest,
      selectedCareOptionScore,
      selectedCareOptionName,
    },
    triageResponse: { ...state.triageResponse, recommendedCareOptions },
    isLoading: false,
  });
}
